import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SharedService } from './shared.service';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ClearingHouseService {

  private jsonOptions = {
    headers: new HttpHeaders().set('Accept', 'application/json').set('Content-Type', 'application/json')
  };

  constructor(private http: HttpClient, private sharedService: SharedService) {}

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      return of(error as T);
    };
  }

  public payfastReport(filter:any){
    return this.http.post(this.sharedService.getFranchiseUrl()+'payment/download/report',filter,this.jsonOptions).pipe(
      catchError(this.handleError<any>('payfastReport', {}))
    )
  }

  public calClearingHouse(filter: any) {
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'finance/clear',filter, this.jsonOptions).pipe(
      catchError(this.handleError<any>('calClearingHouse', {}))
    );
  }

  public createClearingHouse(filter: any) {
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'finance/generate/clear/spreadsheet', filter,this.jsonOptions).pipe(
      catchError(this.handleError<any>('calClearingHouse', {}))
    );
  }

  public processClearingHouseFile(filter: any) {
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'finance/process/clear/spreadsheet', filter,this.jsonOptions).pipe(
      catchError(this.handleError<any>('calClearingHouse', {}))
    );
  }

  public calClearingHouseSingle(bookingId: any) {
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'finance/clear/'+bookingId, this.jsonOptions).pipe(
      catchError(this.handleError<any>('calClearingHouseSingle', {}))
    );
  }

  public createCharge(obj: any) {
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'finance/create/charge',obj ,this.jsonOptions).pipe(
      catchError(this.handleError<any>('calClearingHouseSingle', {}))
    );
  }

  public getCategoryCostSortByField(field: any,offset: any,page: any) {
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'finance/charge/sort/'+field+'/offset/'+offset+'/page/'+page, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getLMFSortByField', {})),
    );
  }

  public financialDistribution() {
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'finance/financial/distribution', this.jsonOptions).pipe(
      catchError(this.handleError<any>('calClearingHouse', {}))
    );
  }

  public getCommissionPercentList() {
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'finance/commission/percent', this.jsonOptions).pipe(
      catchError(this.handleError<any>('getCommissionPercentList', {}))
    );
  }

  public createCommissionPercent(obj: any) {
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'finance/create/commission/percent',obj ,this.jsonOptions).pipe(
      catchError(this.handleError<any>('calClearingHouseSingle', {}))
    );
  }

  public editCommissionPercent(id:any, obj: any) {
    return  this.http.put(this.sharedService.getFranchiseUrl() + 'finance/edit/commission/'+id+'/percent',obj ,this.jsonOptions).pipe(
      catchError(this.handleError<any>('calClearingHouseSingle', {}))
    );
  }

  getSalesPersonClients(userId: string) {
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'sales/total/recruited/'+userId, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getSalesClient', {}))
    );
  }

  getSalesPersonCommissionTransaction(userId: string) {
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'sales/commission/'+userId, this.jsonOptions).pipe(
      catchError(this.handleError<any>('salesPersonTransact', {}))
    );
  }
}
